var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserRoundTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25772_188107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4876 10.8333C11.1864 10.8333 9.32096 8.96785 9.32096 6.66667C9.32096 4.36548 11.1864 2.5 13.4876 2.5C15.7888 2.5 17.6543 4.36548 17.6543 6.66667C17.6543 8.96785 15.7888 10.8333 13.4876 10.8333Z",
    stroke: "#616893",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4873 9.83203C15.5206 9.83203 17.4706 10.6398 18.9084 12.0775C19.1965 12.3656 19.4593 12.6743 19.6953 13H16.933C15.9495 12.2467 14.7398 11.832 13.4873 11.832C11.9844 11.832 10.543 12.4291 9.48032 13.4918C8.41761 14.5545 7.82059 15.9958 7.82059 17.4987C7.82059 18.051 7.37287 18.4987 6.82059 18.4987C6.2683 18.4987 5.82059 18.051 5.82059 17.4987C5.82059 15.4654 6.62832 13.5153 8.0661 12.0775C9.50388 10.6398 11.4539 9.83203 13.4873 9.83203Z",
    fill: "#616893"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60358 1.08218C7.11062 0.86325 7.69914 1.0968 7.91807 1.60384C8.13701 2.11088 7.90345 2.69939 7.39642 2.91833C6.56489 3.27737 5.90127 3.76611 5.4421 4.31775C4.98553 4.86626 4.74744 5.45524 4.70463 6.03015C4.66196 6.60312 4.81063 7.1937 5.17155 7.75696C5.53566 8.32519 6.10936 8.85299 6.87261 9.26987C7.19361 9.4452 7.39328 9.7818 7.39326 10.1476C7.39323 10.5133 7.19351 10.8499 6.87249 11.0252C5.64745 11.6941 4.4112 12.7353 3.48905 13.9806C2.56572 15.2276 2 16.6187 2 18.0003C2 18.5525 1.55228 19.0003 1 19.0003C0.447715 19.0003 0 18.5525 0 18.0003C0 16.0738 0.782596 14.2748 1.88174 12.7904C2.64991 11.753 3.59359 10.8398 4.59404 10.1096C4.16111 9.73019 3.78726 9.30365 3.4876 8.83599C2.91156 7.93702 2.63284 6.91978 2.71015 5.88162C2.78732 4.84541 3.2129 3.86964 3.90494 3.03824C4.59437 2.20998 5.52889 1.54623 6.60358 1.08218Z",
    fill: "#616893"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 16.8346L15.6667 18.5013L19 15.168",
    stroke: "#616893",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25772_188107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRoundTeam);
export default __webpack_public_path__ + "static/media/UserRoundTeam.b88f965ccc512684056d25c48aa6e7a0.svg";
export { ForwardRef as ReactComponent };